(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.initializeHeaderPosition();
      this.logo = document.querySelector('.header__heading-logo');
      this.headerContent = document.querySelector('.header');



      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

      initializeHeaderPosition() {
      const announcementHeight = getComputedStyle(document.documentElement).getPropertyValue('--announcement-height');
      if (announcementHeight) {
        this.header.style.top = announcementHeight;
      } else {
        console.error('Announcement height not set or invalid.');
        }
      }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }


    updateStickyAtcPosition() {
      const stickyAtc = document.querySelector('.section-sticky-atc');
      if (stickyAtc && stickyAtc.classList.contains('sticky-visible')) {
        stickyAtc.style.top = `calc(var(--header-height) + var(--announcement-height))`; // Ajustez selon votre logique
      }
    }

    updateHeaderHeight() {
      if (headerContent) {
        const headerHeight = headerContent.offsetHeight + "px";
        document.documentElement.style.setProperty(
          "--header-height",
           headerHeight
          );
        updateStickyAtcPosition()
        }
      }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (this.getAttribute('data-sticky-type') === 'reduce-logo-size') {
        this.logo.classList.add('header__logo--small');
        this.headerContent.classList.remove('header__padding--small'); 
        updateHeaderHeight();
      }
      document.body.classList.add('header-hidden', 'header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.header.style.top = "";
    }

    reveal() {
      if (this.getAttribute('data-sticky-type') === 'reduce-logo-size') {
        this.logo.classList.add('header__logo--small');
        this.headerContent.classList.add('header__padding--small');
        updateHeaderHeight();
      }
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.remove('header-hidden');
      const announcementHeight = getComputedStyle(document.documentElement).getPropertyValue('--announcement-height');
      this.header.style.top = announcementHeight;
    }

    reset() {
      this.logo.classList.remove('header__logo--small');
      this.headerContent.classList.remove('header__padding--small');
      updateHeaderHeight();
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('header-hidden', 'header-sticky');
      const announcementHeight = getComputedStyle(document.documentElement).getPropertyValue('--announcement-height');
      this.header.style.top = announcementHeight;
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);




  } catch(e) { console.error(e); }
})();
})();
